export default __webpack_public_path__ + "static/media/gaming_Footer_IDNPlay_Supplier.41d4a2d0.svg";